import React from 'react';
import { Box, Button } from '@mui/material';
import {
  AccountApiResponse,
  ChildProfilePageStep,
  CommonPageStep,
} from '../..';
import { verifyDataFormat } from '../../../common/CommonTools';
import { appConfig } from '../../../common/ConfigLoader';
import { useAppSelector } from '../../../store/hooks';
import {
  AppStateAuthentication,
  selectAppAuthentication,
  setAppPageStep,
  updateAppAuthentication,
  updateAppUserProfile,
} from '../../../store/reducer/appStateSlice';
import {
  selectChildProfileData,
  setChildProfileData,
} from '../../../store/reducer/childProfileDataSlice';
import { outsideComponentDispatch } from '../../../store/store';

export interface AvatarSelectElementInterface {
  avatarSelectionBox: JSX.Element;
  saveButton: JSX.Element;
  backButton: JSX.Element;
}

export const AvatarSelectElement = (): AvatarSelectElementInterface => {
  // Redux
  const childProfileData = useAppSelector(selectChildProfileData);
  const authenticationData = useAppSelector(selectAppAuthentication);

  // Hooks
  const [selectedAvatar, setSelectedAvatar] = React.useState(
    childProfileData.avatar,
  );
  const [nextPressed, setNextPressed] = React.useState(false);

  // Child Element
  const AvatarSelectIcon = (props: { icon: string }): JSX.Element => {
    return (
      <React.Fragment>
        <Box
          sx={{
            position: 'relative',
            width: '150px',
            height: '150px',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img
            alt=""
            src={`assets/childProfile/${props.icon}.svg`}
            style={{
              position: 'absolute',
              top: '9px',
              left: '9px',
              width: '141px',
              height: '141px',
              userSelect: 'none',
            }}
            onClick={() => {
              setSelectedAvatar(props.icon);
            }}
          />
          {selectedAvatar === props.icon ? (
            <img
              alt=""
              src="assets/childProfile/selected-ring.svg"
              style={{
                position: 'absolute',
                top: '0px',
                left: '0px',
                userSelect: 'none',
              }}
            />
          ) : null}
        </Box>
      </React.Fragment>
    );
  };

  // Handlers
  return {
    saveButton: (
      <Button
        variant="contained"
        fullWidth={true}
        onClick={() => {
          // UPDATE CHILD PROFILE DATA
          outsideComponentDispatch(
            setChildProfileData({ dataKey: 'avatar', data: selectedAvatar }),
          );

          // RETURN TO CHILD PROFILE CRATE STEP
          outsideComponentDispatch(setAppPageStep(ChildProfilePageStep.CREATE));
        }}
      >
        Save
      </Button>
    ),
    backButton: (
      <Button
        variant="text"
        fullWidth={true}
        onClick={() => {
          outsideComponentDispatch(setAppPageStep(ChildProfilePageStep.CREATE));
        }}
      >
        Back
      </Button>
    ),
    avatarSelectionBox: (
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          gap: '30px',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            width: 'fill-available',
            gap: '30px',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {/* FIRST ROW */}
          <AvatarSelectIcon icon="avatar-cody" />
          <AvatarSelectIcon icon="avatar-astrid" />
          <AvatarSelectIcon icon="avatar-bobo" />
        </Box>
        <Box
          sx={{
            display: 'flex',
            width: 'fill-available',
            gap: '30px',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {/* SECOND ROW */}
          <AvatarSelectIcon icon="avatar-echo" />
          <AvatarSelectIcon icon="avatar-eddy" />
          <AvatarSelectIcon icon="avatar-poppy" />
        </Box>
      </Box>
    ),
  };
};
